export interface Comic {
  id: string;
  title: string;
  category: string;
  tags: string[];
  rating: string;
  chapterCount: number;
  status: '连载' | '完结';
  author: string;
  views: string;
  description: string;
  cover: string;
}

export interface Category {
  name: string;
  en: string;
  count: string;
  desc: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  {
    name: '恋爱',
    en: 'Romance',
    count: '2,400+',
    desc: '心动日常、双向暗恋与深情重逢',
    icon: 'ri-heart-3-line',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    name: '奇幻',
    en: 'Fantasy',
    count: '1,900+',
    desc: '异世界冒险、魔法契约与神魔纪元',
    icon: 'ri-sparkling-2-line',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    name: '校园',
    en: 'Campus',
    count: '1,300+',
    desc: '青春热血、社团生活与青涩情愫',
    icon: 'ri-graduation-cap-line',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    name: '悬疑',
    en: 'Thriller',
    count: '980+',
    desc: '烧脑反转、都市谜案与惊悚推理',
    icon: 'ri-ghost-smile-line',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    name: '完结',
    en: 'Completed',
    count: '3,600+',
    desc: '已完结精品，一口气看到结局',
    icon: 'ri-check-double-line',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    name: '新作',
    en: 'New',
    count: '每周 40+',
    desc: '本周首发连载，第一时间抢先看',
    icon: 'ri-flashlight-line',
    color: 'bg-secondary-100 text-secondary-700',
  },
];

export const comics: Comic[] = [
  {
    id: 'rom-01',
    title: '心动信号时差',
    category: '恋爱',
    tags: ['双向暗恋', '都市', '治愈'],
    rating: '9.6',
    chapterCount: 128,
    status: '连载',
    author: '柚子社',
    views: '12.4w',
    description: '深夜便利店的两份便当，是命运悄悄拉近的时差。身为剪辑师的周然与自由插画师林夏因一场跨时区的直播结缘，双向奔赴的心动在一次次错过与重逢中被无限拉长。',
    cover: 'https://readdy.ai/api/search-image?query=young%20Korean%20couple%20in%20a%20cozy%20cafe%20at%20dusk%2C%20warm%20coral%20orange%20and%20cream%20tones%2C%20soft%20bokeh%20background%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail%2C%20clean%20composition&width=600&height=900&seq=comic-rom-01&orientation=portrait',
  },
  {
    id: 'rom-02',
    title: '指尖的月光',
    category: '恋爱',
    tags: ['奇幻恋爱', '先婚后爱', '甜宠'],
    rating: '9.3',
    chapterCount: 96,
    status: '连载',
    author: '月见拾光',
    views: '9.8w',
    description: '月光只在指尖停留三秒，却足以让骄傲的财阀继承人记住她的名字。一段由契约开始、由真心收尾的都市恋爱童话，甜度与笑点齐飞。',
    cover: 'https://readdy.ai/api/search-image?query=rooftop%20at%20night%20under%20bright%20moon%2C%20two%20silhouettes%20of%20young%20lovers%2C%20soft%20warm%20amber%20glow%2C%20romantic%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail%2C%20dreamy%20composition&width=600&height=900&seq=comic-rom-02&orientation=portrait',
  },
  {
    id: 'rom-03',
    title: '镜中恋人',
    category: '恋爱',
    tags: ['奇幻', '穿书', '宿命'],
    rating: '8.9',
    chapterCount: 82,
    status: '连载',
    author: '北岸胶片',
    views: '6.7w',
    description: '她每照一次镜子，就会进入另一个平行世界的自己。而那个世界里，始终有一个等她回家的少年。虚实交错间，爱情有了第二种答案。',
    cover: 'https://readdy.ai/api/search-image?query=reflective%20mirror%20with%20a%20mysterious%20smiling%20girl%2C%20vintage%20vanity%20table%2C%20warm%20golden%20light%2C%20romantic%20fantasy%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-rom-03&orientation=portrait',
  },
  {
    id: 'fan-01',
    title: '星尘契约',
    category: '奇幻',
    tags: ['魔法', '冒险', '史诗'],
    rating: '9.8',
    chapterCount: 214,
    status: '连载',
    author: '灼夜工作室',
    views: '21.6w',
    description: '被帝国流放的废柴学徒，意外解开千年星尘封印，成为唯一能契约群星的人。从尘埃到星辰，一段宏大的魔法史诗由此展开。',
    cover: 'https://readdy.ai/api/search-image?query=young%20mage%20holding%20a%20glowing%20star%20crystal%20in%20a%20magical%20library%2C%20warm%20amber%20and%20soft%20teal%20accents%2C%20epic%20fantasy%20Korean%20webtoon%20cover%2C%20high%20detail%2C%20dramatic%20lighting&width=600&height=900&seq=comic-fan-01&orientation=portrait',
  },
  {
    id: 'fan-02',
    title: '龙裔与孤塔',
    category: '奇幻',
    tags: ['龙族', '成长', '羁绊'],
    rating: '9.4',
    chapterCount: 173,
    status: '连载',
    author: '灰烬之塔',
    views: '15.3w',
    description: '世间最后一位龙裔，在众叛亲离中独自攀上孤塔。塔中住着被封印的龙魂，也藏着他与整个世界为敌的秘密。',
    cover: 'https://readdy.ai/api/search-image?query=dragon%20descendant%20standing%20before%20an%20ancient%20tower%2C%20dramatic%20clouds%2C%20warm%20firelight%2C%20epic%20fantasy%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-fan-02&orientation=portrait',
  },
  {
    id: 'fan-03',
    title: '第七封印师',
    category: '奇幻',
    tags: ['黑暗', '热血', '战斗'],
    rating: '9.1',
    chapterCount: 141,
    status: '连载',
    author: '夜枭绘',
    views: '11.9w',
    description: '七道封印逐一崩坏，人间将坠入永夜。少年以血为墨、以心为锁，在诸神黄昏前，誓要补全最后一道封印。',
    cover: 'https://readdy.ai/api/search-image?query=mysterious%20seal%20master%20with%20glowing%20runes%2C%20hooded%20figure%2C%20warm%20torchlight%2C%20dark%20fantasy%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-fan-03&orientation=portrait',
  },
  {
    id: 'cam-01',
    title: '夏末的告白信',
    category: '校园',
    tags: ['青春', '初恋', '治愈'],
    rating: '9.2',
    chapterCount: 108,
    status: '连载',
    author: '青柠汽水',
    views: '10.4w',
    description: '高三那年夏天，课桌里多了一封没有署名的告白信。女孩追着信纸里散落的梧桐叶，一路跑进了一场盛大又含蓄的青春。',
    cover: 'https://readdy.ai/api/search-image?query=high%20school%20rooftop%20in%20summer%2C%20girl%20reading%20a%20letter%2C%20golden%20sunset%2C%20warm%20tones%2C%20campus%20romance%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-cam-01&orientation=portrait',
  },
  {
    id: 'cam-02',
    title: '倒数日晴空',
    category: '校园',
    tags: ['社团', '热血', '友情'],
    rating: '8.8',
    chapterCount: 77,
    status: '完结',
    author: '晴空剧场',
    views: '7.6w',
    description: '摄影社解散前的最后 100 天，五位性格迥异的少年决定用镜头记录彼此最真实的模样。关于友情、成长与告别的青春群像。',
    cover: 'https://readdy.ai/api/search-image?query=school%20corridor%20with%20two%20students%20sharing%20earphones%2C%20bright%20warm%20daylight%2C%20youthful%20campus%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-cam-02&orientation=portrait',
  },
  {
    id: 'cam-03',
    title: '毕业前夜',
    category: '校园',
    tags: ['青春', '群像', '感动'],
    rating: '9.0',
    chapterCount: 64,
    status: '完结',
    author: '毕业季企划',
    views: '5.9w',
    description: '毕业典礼前夜，六个好朋友在空教室里许下十年后的约定。当散场灯光亮起，他们才明白——告别，也是一种开始。',
    cover: 'https://readdy.ai/api/search-image?query=graduation%20ceremony%20at%20night%2C%20confetti%20and%20warm%20lights%2C%20group%20of%20friends%20laughing%2C%20campus%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-cam-03&orientation=portrait',
  },
  {
    id: 'mys-01',
    title: '深渊回响',
    category: '悬疑',
    tags: ['惊悚', '都市怪谈', '反转'],
    rating: '9.5',
    chapterCount: 156,
    status: '连载',
    author: '回声匣子',
    views: '18.2w',
    description: '雨夜里反复响起的同一段求救录音，指向一座早已废弃的广播塔。主播姜黎循着回响深入谜团，却发现自己也是故事的一部分。',
    cover: 'https://readdy.ai/api/search-image?query=dark%20alley%20with%20a%20faint%20glowing%20silhouette%2C%20suspenseful%20mood%2C%20warm%20amber%20streetlights%2C%20mystery%20thriller%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-mys-01&orientation=portrait',
  },
  {
    id: 'mys-02',
    title: '午夜标本馆',
    category: '悬疑',
    tags: ['推理', '超自然', '密室'],
    rating: '9.3',
    chapterCount: 92,
    status: '完结',
    author: '猫头鹰守卫',
    views: '9.1w',
    description: '闭馆后的自然博物馆，会说话的人偶标本邀请唯一的守夜人解开七道谜题。每答对一道，真相就离黑暗更近一步。',
    cover: 'https://readdy.ai/api/search-image?query=mysterious%20natural%20history%20museum%20at%20midnight%2C%20flickering%20lanterns%2C%20eerie%20warm%20glow%2C%20mystery%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-mys-02&orientation=portrait',
  },
  {
    id: 'mys-03',
    title: '无声证词',
    category: '悬疑',
    tags: ['刑侦', '本格推理', '烧脑'],
    rating: '9.7',
    chapterCount: 188,
    status: '连载',
    author: '墨线档案',
    views: '20.8w',
    description: '法医秦屿能听见死者临终前最后五秒的无声证词。当连环案的真凶开始利用这个能力制造完美不在场证明，一场正与邪的推理拉锯战开启。',
    cover: 'https://readdy.ai/api/search-image?query=detective%20examining%20a%20case%20board%20with%20pinned%20photos%2C%20warm%20desk%20lamp%2C%20suspense%20thriller%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-mys-03&orientation=portrait',
  },
  {
    id: 'fin-01',
    title: '灼热的棋局',
    category: '奇幻',
    tags: ['棋盘战争', '斗智', '史诗'],
    rating: '9.6',
    chapterCount: 210,
    status: '完结',
    author: '落子有声',
    views: '19.5w',
    description: '当世界变成一张棋盘，凡人亦可执子封神。天才棋手与神秘执棋者的对弈，步步惊心，落子无悔。',
    cover: 'https://readdy.ai/api/search-image?query=grand%20chessboard%20arena%20with%20glowing%20pieces%2C%20determined%20young%20player%2C%20warm%20dramatic%20lighting%2C%20fantasy%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-fin-01&orientation=portrait',
  },
  {
    id: 'fin-02',
    title: '重逢在冬季',
    category: '恋爱',
    tags: ['久别重逢', '治愈', 'be'],
    rating: '9.4',
    chapterCount: 74,
    status: '完结',
    author: '南巷知白',
    views: '8.7w',
    description: '五年后再次相遇，是在初雪的便利店门口。曾经的误会与遗憾，都在一杯热可可的温度里慢慢融化。',
    cover: 'https://readdy.ai/api/search-image?query=winter%20city%20street%20reunion%2C%20snow%20falling%2C%20two%20people%20facing%20each%20other%2C%20warm%20coat%20colors%2C%20emotional%20romance%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-fin-02&orientation=portrait',
  },
  {
    id: 'fin-03',
    title: '旋转门事件',
    category: '悬疑',
    tags: ['本格', '都市', '反转'],
    rating: '8.7',
    chapterCount: 68,
    status: '完结',
    author: '微光侦探',
    views: '6.2w',
    description: '酒店旋转门在监控里永远多转了一圈。看似完美的密室，藏着一个关于时间与谎言的精妙设计。',
    cover: 'https://readdy.ai/api/search-image?query=revolving%20glass%20door%20with%20a%20shadowy%20figure%2C%20dim%20warm%20lobby%2C%20mystery%20thriller%20Korean%20webtoon%20cover%20illustration%2C%20high%20detail&width=600&height=900&seq=comic-fin-03&orientation=portrait',
  },
];

export interface RankItem {
  rank: number;
  comic: Comic;
  change: 'up' | 'down' | 'flat';
}

export const rankings: RankItem[] = [
  { rank: 1, comic: comics[3], change: 'up' },
  { rank: 2, comic: comics[11], change: 'up' },
  { rank: 3, comic: comics[0], change: 'flat' },
  { rank: 4, comic: comics[9], change: 'down' },
  { rank: 5, comic: comics[12], change: 'up' },
  { rank: 6, comic: comics[4], change: 'flat' },
  { rank: 7, comic: comics[6], change: 'down' },
  { rank: 8, comic: comics[5], change: 'up' },
  { rank: 9, comic: comics[1], change: 'flat' },
  { rank: 10, comic: comics[10], change: 'up' },
];

export const updates = [
  { label: '恋爱', items: comics.filter((c) => c.category === '恋爱') },
  { label: '奇幻', items: comics.filter((c) => c.category === '奇幻') },
  { label: '校园', items: comics.filter((c) => c.category === '校园') },
  { label: '悬疑', items: comics.filter((c) => c.category === '悬疑') },
];

export const completed = comics.filter((c) => c.status === '完结');

export const faqs = [
  {
    q: '看漫画需要下载 App 吗？',
    a: '不需要。本站为高清韩国漫画在线阅读平台，支持电脑、平板和手机浏览器直接观看，无需安装任何客户端，登录后即可收藏、追更与同步阅读进度。',
  },
  {
    q: '漫画一般多久更新一次？',
    a: '连载中的作品通常每周更新 1 至 3 话，热门作品会保持每日更新。你可以在详情页开启「追更提醒」，每次更新第一时间收到通知，不错过任何一话。',
  },
  {
    q: '完结作品和连载作品有什么区别？',
    a: '完结作品已更新至大结局，可以一口气追完，适合不想等待的读者；连载作品仍在持续更新，情节更加新鲜热乎。站内提供「完结」「连载」双筛选，方便按阅读习惯挑选。',
  },
  {
    q: '人气排行榜多久刷新一次？',
    a: '排行榜基于近 24 小时的真实阅读、收藏与评分数据实时计算，每天 0 点刷新一次。榜单分为「总榜」「恋爱榜」「奇幻榜」「校园榜」「悬疑榜」等，可随时切换查看。',
  },
  {
    q: '如何按题材快速找到想看的漫画？',
    a: '你可以通过顶部导航进入「题材分类」，按恋爱、奇幻、校园、悬疑等大题材筛选；也可以在站内搜索框直接输入作品名、作者或关键词，结果会即时匹配。',
  },
  {
    q: '支持离线缓存和阅读进度同步吗？',
    a: '支持。登录后阅读进度会在多设备间自动同步；你还可以将正在追的作品加入书架并缓存到本地，无网络时也能离线阅读已下载的章节。',
  },
];